import React, { useMemo } from "react";
import { observer, inject } from "mobx-react";
import { useTheme } from "styled-components";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import { ScrollDiv } from "../../components/Common";

const useSortableData = (items, config) => {
  const [sortConfig, setSortConfig] = React.useState(config);
  const sortedItems = useMemo(() => {
    let sortableItems = [...items];
    if (sortConfig !== null) {
      if (sortConfig.key?.includes("DATE")) {
        sortableItems.sort((a, b) => {
          if (new Date(a[sortConfig.key]) <= new Date(b[sortConfig.key])) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (new Date(a[sortConfig.key]) > new Date(b[sortConfig.key])) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      } else {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
    }

    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key) => {
    let direction = "descending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "descending"
    ) {
      direction = "ascending";
    }
    setSortConfig({ key, direction });
  };
  return { sortedItems, requestSort, sortConfig };
};

const Tabel = ({
  tab,
  keys,
  items,
  translation,
  config,
  maxHeight,
  toDetails,
  onRowClick,
  onToggle,
  onBedekToggle,
  onIsBedekToggle,
  onIsContSaleToggle,
  isRowClickable,
  currency,
}) => {
  const theme = useTheme();
  const { sortedItems } = useSortableData(items, {
    ...config,
  });

  return (
    <>
      {sortedItems?.length > 0 && (
        <>
          <TableHeader
            keys={keys}
            items={items}
            translation={translation}
          ></TableHeader>
          <ScrollDiv
            style={{
              overflowY: "auto",
              maxHeight: maxHeight ? maxHeight : "50vh",
              width: "inherit",
              "&::WebkitScrollbar": {
                backgroundColor: theme.color.gray30,
                width: "8px",
              },
              "&::WebkitScrollbarThumb": {
                height: "1%",
                width: "8px",
                backgroundColor: theme.color.gray70,
                borderRaduis: 4,
              },
            }}
          >
            {sortedItems.map((item, index) => (
              <TableRow
                isRowClickable={isRowClickable}
                key={index}
                keys={keys}
                index={index}
                tab={tab}
                row={item}
                toDetails={toDetails}
                onRowClick={onRowClick}
                onToggle={onToggle}
                onBedekToggle={onBedekToggle}
                onIsBedekToggle={onIsBedekToggle}
                onIsContSaleToggle={onIsContSaleToggle}
                currency={currency}
              ></TableRow>
            ))}
          </ScrollDiv>
        </>
      )}
    </>
  );
};

export default inject()(observer(Tabel));
